// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__RYhQe","logo":"Sidebar_logo__sOh3F","content":"Sidebar_content__LPLVx"};